<template>
  <section>
    <v-layout wrap row v-if="loaded">
      <v-flex>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="getVotingVoters"
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="py-4">{{ props.item.votingDate }}</td>
            <td class="py-4">
              {{ props.item.stepOneVotes && props.item.stepOneVotes.length > 0 ? 'One ' : '' }}
              {{ props.item.stepTwoVotes && props.item.stepTwoVotes.length > 0 ? 'Two ' : '' }}
            </td>
            <td class="py-4">{{ props.item.email }}</td>
            <td class="py-4">{{ props.item.firstName }} {{ props.item.lastName }}</td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  color="lime"
                  fab flat
                  slot="activator"
                  @click.stop="showDetails(props.item)"
                >
                  <v-icon>info</v-icon>
                </v-btn>
                <span>Details</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <div v-else ><h3>No votes yet</h3></div>

    <v-dialog v-model="visibleDetails" v-if="currentItem" max-width="600px">
      <v-card class="pa-2" >
        <v-card-title>
          <span class="headline mb-0 text-md-center">Details about voter</span>
          <div style="width: 100%" :key='step.key' v-for='step in steps'>
            <h2 v-if="currentItem[step.key]" >{{ step.name }}</h2>
            <v-flex class="py-2">
              <v-data-table
                hide-actions
                v-if="currentItem[step.key]"
                :headers="itemHeaders"
                :items="currentItem[step.key]"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="py-4">{{ getCategory(props.item.nominationCategoryId).title }}</td>
                  <td class="py-4">
                    <div :key='nid' v-for="nid in props.item.nomineeIds">
                      {{getNominee(nid).name }}
                    </div>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" flat @click="hideDetails">Close</v-btn>
        </v-card-actions>
      </v-card> 
    </v-dialog>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { sort, path, clone } from 'ramda'

export default {
  name: "AwardsVotingVoters",
  data () {
    return {
      loaded: false,
      currentItem: null,
      visibleDetails: false,
      steps: [{ name: 'Step One', key: 'stepOneVotes' }, { name: 'Step Two', key: 'stepTwoVotes' }],
      headers: [
        { text: 'Date', value: 'votingDate', search: false, sortable: false },
        { text: 'Round', value: 'round', search: false, sortable: false },
        { text: 'Email', value: 'email', search: false, sortable: false },
        { text: 'Name', value: 'name', search: false, sortable: false },
        { text: 'Actions', sortable: false, align: 'center', width: 30 }
      ],
      itemHeaders: [
        { text: 'Category', value: 'category', search: false, sortable: false },
        { text: 'Company', value: 'vote', search: false, sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'nomineesList',
      'getNominationsCategories',
      'getVotingVoters'
    ])
  },
  methods: {
    ...mapActions([
      'getNominationsCategoriesList',
      'getNomineesList',
      'fetchVotingVoters'
    ]),
    async fetchNominees () {
      const getParams = {
        filter: {},
        sort: 'Asc',
        name: null
      }
      this.getNomineesList(getParams)
    },
    async fetchTableData () {
      await this.fetchVotingVoters()
    },
    getCategory(id) {
      return this.getNominationsCategories.find(i => i.id === id) || { title: '[Not found]'}
    },
    getNominee(id) {
      return this.nomineesList.find(i => i.id === id) || { name: '[Not found]'}
    },
    showDetails (item) {
      this.currentItem = item
      this.visibleDetails = true
    },
    hideDetails () {
      this.visibleDetails = false
      this.currentItem = null
    }
  },
  async created () {
    this.loaded = false
    await Promise.all([
      this.getNominationsCategoriesList(),
      this.fetchTableData(),
      this.fetchNominees()
    ])
    this.loaded = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Awards/Voting/Votes/index.vue